<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
      <van-icon name="arrow-left" @click="backPath" />
      <div class="top_name">我的地址</div>
      <div class="top_icon" />
    </div>
    <van-search ref="searchVal" v-model="keyWords" class="classify_ser" style="width:100%" placeholder="输入省市区，姓名，手机号搜索"
                shape="round" @search="onSearch" @input="inputWord"
    />
    <div class="address_box">
      <van-address-list v-model="chosenAddressId" :list="list" default-tag-text="默认" :switchable="isChoose"
                        add-button-text="+ 新增地址" @add="onAdd" @edit="onEdit" @select="selectAddress"
      />
    </div>
  </div>
</template>

<script>
import './index.scss'
import { userReceiptAddress_list } from '@/api/user'
export default {
  data() {
    return {
      keyWords: '',
      chosenAddressId: '',
      isChoose: false,
      list: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    this.chosenAddressId = this.$route.query.aId || ''
    this.isChoose = this.$route.query.aId !== undefined
    this.getAddressList()
  },
  methods: {
    backPath() { window.history.back() },
    getAddressList() {
      userReceiptAddress_list({ page: 1, limit: 99, keyWords: this.keyWords }).then(res => {
        var list = res.data.list
        for (const i in list) {
          const parms = {
            id: list[i].receiptAddressId,
            provinceId: list[i].provinceId,
            name: list[i].receiptPersonName,
            tel: list[i].receiptMobile,
            address: list[i].receiptProvince + list[i].receiptCity + list[i].receiptArea + list[i].receiptAddress,
            isDefault: list[i].isDefault
          }
          // this.list.unshift(parms)
          this.list.push(parms)
        }
      })
    },
    selectAddress(item, index) {
      window.history.back()
      sessionStorage.setItem('address', JSON.stringify(item))
    },
    onAdd() { this.$router.push('/user/addressDetail?id=0') },
    onEdit(item, index) {
      this.$router.push('/user/addressDetail?id=' + item.id)
    },
    onSearch() {
      this.list = []
      this.getAddressList()
    },
    inputWord(e) {
      console.log('inputWord', e)
      if (e.length === 0) {
        this.list = []
        this.getAddressList()
      }
    }
  }
}
</script>

<style>
body {
  background: #f7f7f7;
}
</style>
